import { LinearProgress } from '@material-ui/core';
import styled from 'styled-components';

import { ThemeProp } from '../../theme/Themes';

interface ContainerProps {
  $horizontalPadding?: string;
}
const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0.5rem ${(props) => props.$horizontalPadding || '0'};
`;
const CustomLinearProgress = styled(LinearProgress)`
  &.MuiLinearProgress-colorPrimary {
    background-color: ${(props: ThemeProp) => props.theme.colors.primary.c200};

    .MuiLinearProgress-barColorPrimary {
      background-color: ${(props: ThemeProp) => props.theme.colors.primary.c500};
    }
  }
`;

interface StyledLinearProgressProps {
  horizontalPadding?: string;
}

const StyledLinearProgress = ({ horizontalPadding }: StyledLinearProgressProps) => (
  <Container $horizontalPadding={horizontalPadding}>
    <CustomLinearProgress />
  </Container>
);

export default StyledLinearProgress;
